import { render, staticRenderFns } from "./56-voice.vue?vue&type=template&id=300b4634&scoped=true"
import script from "./56-voice.vue?vue&type=script&lang=js"
export * from "./56-voice.vue?vue&type=script&lang=js"
import style0 from "./56-voice.vue?vue&type=style&index=0&id=300b4634&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.10.0_prettier@2.8.8_vue-template-compiler@2.7.16_webpack@5.90.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300b4634",
  null
  
)

export default component.exports